export default __webpack_public_path__ + "static/media/property_755.f77e053b.png";